<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="1100px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-dolly</v-icon>
              <span class="px-3">{{ $t('Edit Destructed Asset') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap justify-content-end>
                <v-flex xs4 pa-2>
                  <v-menu offset-y max-width="290" full-width :close-on-content-click="false" v-model="datePicker">
                    <v-text-field
                      slot="activator"
                      :value="updateForm.damaged_date"
                      :label="`${$t('Date')} *`"
                      prepend-inner-icon="event"
                      box
                      readonly
                      hide-details
                      name="damaged_date"
                      background-color="white"
                      autocomplete="off"
                      :error="errors.has('damaged_date')"
                      v-validate="'required|date_format:yyyy-MM-dd'"
                    />
                    <v-date-picker v-model="updateForm.damaged_date" @change="datePicker = false" />
                  </v-menu>
                </v-flex>

                <v-flex xs4 pa-2>
                  <v-autocomplete
                    v-model="updateForm.asset_type"
                    :items="assetTypes"
                    :label="`${$t('Asset Type')} *`"
                    box
                    hide-details
                    readonly
                    background-color="white"
                    :error="errors.has('asset_type')"
                    data-vv-name="asset_type"
                    :menu-props="{ transition: 'slide-y-transition' }"
                    v-validate="'required'"
                  />
                </v-flex>

                <v-flex xs4 pa-2>
                  <v-autocomplete
                    v-model="updateForm.damaged_type"
                    :items="damagedTypes"
                    :label="`${$t('Destructed Type')} *`"
                    box
                    hide-details
                    background-color="white"
                    :error="errors.has('damaged_type')"
                    data-vv-name="damaged_type"
                    :menu-props="{ transition: 'slide-y-transition' }"
                    v-validate="'required'"
                  />
                </v-flex>

                <v-flex xs12 pa-2>
                  <v-textarea
                    v-model="updateForm.note"
                    :label="$t('Note')"
                    name="damaged_note"
                    box
                    hide-details
                    height="80"
                    background-color="white"
                    :error="errors.has('note')"
                  />
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 style="margin-top: 20px">
              <v-layout row wrap class="form-table-header">
                <v-flex class="form-table-content">
                  <v-layout row>
                    <v-flex xs2 pa-2>#</v-flex>
                    <v-flex xs10 pa-2>{{ $t('Product') }}</v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 class="form-table-content">
                  <v-layout row>
                    <v-flex xs5 pa-2 v-if="hasCollection">{{ $t('Collections') }}</v-flex>
                    <v-flex pa-2>{{ $t('Quantity') }}</v-flex>
                    <v-flex pa-2>{{ $t('Destructed Date') }}</v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs1 class="form-table-content">
                  <v-tooltip top>
                    <v-btn label @click="addRow()" small slot="activator" icon color="green">
                      <v-icon color="white">add</v-icon>
                    </v-btn>
                    <span>{{ $t('Add new row') }}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>

              <template v-if="rowNumbers > 0">
                <v-layout row wrap v-for="(row, index) in rowNumbers" :key="index">
                  <v-flex>
                    <v-layout row>
                      <v-flex xs2 class="pa-1" style="text-align: center; margin-top: 20px; font-size: 16px">{{
                        index + 1
                      }}</v-flex>
                      <v-flex xs10 class="pa-1">
                        <v-autocomplete
                          v-model="updateForm.product_id_fk[index]"
                          :label="`${$t('Product')} *`"
                          :items="updateForm.asset_type === 'Current' ? productsList : assetsList"
                          hide-details
                          box
                          :data-vv-name="'product_id_fk' + (index + 1)"
                          background-color="white"
                          :error="errors.has('product_id_fk' + (index + 1))"
                          v-validate="'required'"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs6>
                    <v-layout row>
                      <v-flex xs6 pa-1 v-if="hasCollection">
                        <v-autocomplete
                          v-model="updateForm.collection_id_fk[index]"
                          :label="$t('Collections')"
                          :items="collections[index]"
                          item-text="collection_name"
                          item-value="collection_id"
                          hide-details
                          box
                          :disabled="collections[index] && collections[index].length === 0"
                          :data-vv-name="'Collections' + (index + 1)"
                          background-color="white"
                          :error="errors.has('Collections' + (index + 1))"
                        />
                      </v-flex>
                      <v-flex pa-1>
                        <v-text-field
                          v-model.number="updateForm.damaged_quantity[index]"
                          :label="`${$t('Quantity')} *`"
                          hide-details
                          box
                          :data-vv-name="'damaged_quantity' + (index + 1)"
                          background-color="white"
                          :error="errors.has('damaged_quantity' + (index + 1))"
                          v-validate="'required|decimal:3|min_value:0'"
                          data-vv-delay="1000"
                        />
                      </v-flex>
                      <v-flex pa-1>
                        <v-menu
                          offset-y
                          max-width="290"
                          full-width
                          :close-on-content-click="false"
                          v-model="damagedDateMenu[index]"
                        >
                          <v-text-field
                            slot="activator"
                            :value="updateForm.damaged_date_time[index]"
                            :label="`${$t('Destructed Date')} *`"
                            prepend-inner-icon="event"
                            box
                            readonly
                            hide-details
                            name="destructed_date"
                            background-color="white"
                            autocomplete="off"
                            :error="errors.has('destructed_date')"
                            v-validate="'required|date_format:yyyy-MM-dd'"
                          />
                          <v-date-picker
                            @change="damagedDateMenu[index] = false"
                            v-model="updateForm.damaged_date_time[index]"
                          />
                        </v-menu>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex
                    xs1
                    :class="index + 1 === rowNumbers && index + 1 > 1 ? 'pt-3' : 'pa-3'"
                    style="text-align: center"
                  >
                    <v-tooltip top>
                      <v-btn label flat @click="removeRow(index)" small slot="activator" icon color="error">
                        <v-icon>delete</v-icon>
                      </v-btn>
                      <span>{{ $t('Remove this row') }}</span>
                    </v-tooltip>
                    <v-tooltip top v-if="index + 1 === rowNumbers && index + 1 > 1">
                      <v-btn label @click="addRow()" small flat slot="activator" icon>
                        <v-icon size="28" color="green">add_circle</v-icon>
                      </v-btn>
                      <span>{{ $t('Add new row') }}</span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
              </template>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :disabled="rowNumbers < 1" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnUpdateLoading: false,
      btnApproveLoading: false,
      rowNumbers: 0,
      damagedDate: [],
      damagedDateMenu: [],
      datePicker: false,
      updateForm: {
        note: '',
        damaged_date: '',
        product_id_fk: [],
        collection_id_fk: [],
        damaged_quantity: [],
        damaged_date_time: []
      },
      collections: []
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      productsList: 'transfers/getTransferProductsList',
      damageInfo: 'destructedAssets/getDamagedProductInfo',
      assetsList: 'fixedAssets/getFullFixedAssetsList',
      assetTypes: 'destructedAssets/getAssetTypes',
      damagedTypes: 'destructedAssets/getDamagedTypes',
      settings: 'configurations/getSystemSettings'
    }),
    hasCollection() {
      return this.settings.production_collections === 'Active'
    }
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.rowNumbers = this.damageInfo.data_detail.length
          this.updateForm.damaged_id = this.damageInfo.data.damaged_id
          this.updateForm.damaged_type = this.damageInfo.data.damaged_type
          this.updateForm.asset_type = this.damageInfo.data.asset_type
          this.updateForm.note = this.damageInfo.data.damaged_note
          this.updateForm.damaged_date = this.damageInfo.data.damaged_date

          this.updateForm.product_id_fk = []
          this.updateForm.collection_id_fk = []
          this.updateForm.damaged_quantity = []
          this.updateForm.damaged_date_time = []
          this.damagedDate = []

          this.damageInfo.data_detail.forEach((e, index) => {
            this.updateForm.product_id_fk.push(e.product_id_fk)
            this.updateForm.collection_id_fk.push(e.collection_id_fk)
            if (this.updateForm.collection_id_fk[index]) {
              this.findCollections(index)
              this.updateForm.damaged_quantity.push(e.damaged_collection_quantity)
            } else {
              this.updateForm.damaged_quantity.push(e.damaged_quantity)
            }
            this.updateForm.damaged_date_time.push(e.damaged_date_time.substr(0, 10))
            this.damagedDate.push(e.damaged_date_time.substr(0, 10))
            this.damagedDateMenu.push(false)
          })

          if (this.damageInfo !== null) {
            this.addEscKeyListener()
          }
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updateDamagedProductInfo: 'destructedAssets/updateDamagedProductInfo'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    addRow() {
      this.damagedDate[this.rowNumbers] = ''
      this.damagedDateMenu[this.rowNumbers] = false
      this.rowNumbers = this.rowNumbers + 1
    },

    removeRow(index) {
      this.rowNumbers = this.rowNumbers - 1
      this.updateForm.product_id_fk.splice(index, 1)
      this.updateForm.collection_id_fk.splice(index, 1)
      this.updateForm.damaged_quantity.splice(index, 1)
      this.updateForm.damaged_date_time.splice(index, 1)
      this.damagedDate.splice(index, 1)
      this.damagedDateMenu.splice(index, 1)
    },

    findCollections(index) {
      const filteredProduct = this.productsList.filter(item => item.value === this.updateForm.product_id_fk[index])[0]
      this.collections[index] = filteredProduct.collections
    },

    findCollection(index) {
      return this.collections[index].filter(item => item.collection_id === this.updateForm.collection_id_fk[index])[0]
    },

    collectionQuantity(index) {
      return this.findCollection(index).collection_quantity
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnUpdateLoading = true

            let formData = new FormData(event.target)
            formData.append('asset_type', this.updateForm.asset_type)
            formData.append('damaged_type', this.updateForm.damaged_type)

            this.updateForm.product_id_fk.forEach((p, index) => {
              formData.append('product_id_fk[' + [index] + ']', p)
              formData.append('collection_id_fk[' + index + ']', this.updateForm.collection_id_fk[index] || '')
              if (this.updateForm.collection_id_fk[index]) {
                formData.append('damaged_collection_quantity[' + index + ']', this.updateForm.damaged_quantity[index])
                formData.append(
                  'damaged_quantity[' + index + ']',
                  (this.updateForm.damaged_quantity[index] * this.collectionQuantity(index)).toFixed(2)
                )
              } else {
                formData.append('damaged_collection_quantity[' + index + ']', '')
                formData.append('damaged_quantity[' + index + ']', this.updateForm.damaged_quantity[index])
              }
            })

            this.updateForm.damaged_date_time.forEach((ed, index) => {
              formData.append('damaged_date_time[' + [index] + ']', ed)
            })

            let payload = { id: this.updateForm.damaged_id, formData }
            this.updateDamagedProductInfo(payload)
              .then(() => {
                this.btnUpdateLoading = false
                this.damagedDate = []
                this.damagedDateMenu = []
                this.product_id_fk = []
                this.updateForm.damaged_quantity = []
                this.updateForm.damaged_date_time = []
                this.$emit('updated')
                this.$emit('hidemodal')
              })
              .catch(() => {
                this.btnUpdateLoading = false
              })
          }
        })
        .catch(() => {
          this.btnUpdateLoading = false
        })
    }
  }
}
</script>

<style scoped />
